import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// 🔐 Firebase-konfigurasjon
const firebaseConfig = {
  apiKey: "AIzaSyBG6O_PEOSYAxAya6LFZKIXofXRrou19XI",
  authDomain: "kode-essens-global.firebaseapp.com",
  projectId: "kode-essens-global",
  storageBucket: "kode-essens-global.firebasestorage.app",
  messagingSenderId: "325797968551",
  appId: "1:325797968551:web:1e040bad0052bc549d3982"
};

// ✅ Sjekk om appen er initialisert før vi oppretter den
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

// Eksporter Firestore
const db = getFirestore(app);
export { db };
